import ScoreByDeviceWidget from './ScoreByDeviceWidget';
export default ScoreByDeviceWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/ScoreByDeviceWidget/index.js